
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  FilterGroup,
  SelectFilter,
} from '@drawbotics/react-drylus';
import Playground, { PropsTable } from '~/components/Playground';
import { ControlledField, ControlledMultiField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`FilterGroup`}</h1>
<p>{`In order to allow decluttering of the UI in smaller screen sizes, we provide an additional component called `}<inlineCode parentName="p">{`FilterGroup`}</inlineCode>{`. You can see the API below:`}</p>
<PropsTable component={FilterGroup} mdxType="PropsTable" />
<p>{`By wrapping your filters (and other elements if necessary) with this component, they will be rendered in a separate panel in mobile, which is accesed by pressing the button rendered by the component.`}</p>
<Playground __position={1} __code={`<FilterGroup
  label="Example"
  icon="filter"
  onClear={x => x}>
  <SelectFilter
    fullWidth
    label="Example 1"
    onClear={x => x}
    onChange={x => x}
    options={[{
      label: 'Something 1',
      value: '1',
    }, {
      label: 'Something 2',
      value: '2',
    }, {
      label: 'Something 3',
      value: '3',
    }]} />
  <SelectFilter
    fullWidth
    label="Example 2"
    onClear={x => x}
    onChange={x => x}
    options={[{
      label: 'Something 1',
      value: '1',
    }, {
      label: 'Something 2',
      value: '2',
    }, {
      label: 'Something 3',
      value: '3',
    }]} />
</FilterGroup>`} mdxType="Playground">
  <FilterGroup label="Example" icon="filter" onClear={x => x} mdxType="FilterGroup">
    <SelectFilter fullWidth label="Example 1" onClear={x => x} onChange={x => x} options={[{
          label: 'Something 1',
          value: '1'
        }, {
          label: 'Something 2',
          value: '2'
        }, {
          label: 'Something 3',
          value: '3'
        }]} mdxType="SelectFilter" />
    <SelectFilter fullWidth label="Example 2" onClear={x => x} onChange={x => x} options={[{
          label: 'Something 1',
          value: '1'
        }, {
          label: 'Something 2',
          value: '2'
        }, {
          label: 'Something 3',
          value: '3'
        }]} mdxType="SelectFilter" />
  </FilterGroup>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;